// Auto-generated by scripts/generateModules.mjs

export const modules = [
  {
    "id": "seniors",
    "basePath": "/modules/seniors/",
    "sections": [
      {
        "id": "01-What-is-an-Online-Scam",
        "titleGuess": "What Is An Online Scam"
      },
      {
        "id": "02-SMS-Phone-Scam-Detection-Tips",
        "titleGuess": "SMS Phone Scam Detection Tips"
      },
      {
        "id": "03-Investment-Scam-&-Phishing-Website-Alert",
        "titleGuess": "Investment Scam & Phishing Website Alert"
      }
    ]
  },
  {
    "id": "students",
    "basePath": "/modules/students/",
    "sections": [
      {
        "id": "01-Internet-Basics-&-Privacy-Protection",
        "titleGuess": "Internet Basics & Privacy Protection"
      },
      {
        "id": "02-Phishing-&-Social-Engineering",
        "titleGuess": "Phishing & Social Engineering"
      },
      {
        "id": "03-Secure-Passwords-&-MFA-Tips",
        "titleGuess": "Secure Passwords & MFA Tips"
      }
    ]
  },
  {
    "id": "parents",
    "basePath": "/modules/parents/",
    "sections": [
      {
        "id": "01-Family-Online-Risk-Overview",
        "titleGuess": "Family Online Risk Overview"
      },
      {
        "id": "02-Social-Media-and-Child-Behavior-Management",
        "titleGuess": "Social Media And Child Behavior Management"
      }
    ]
  },
  {
    "id": "business",
    "basePath": "/modules/business/",
    "sections": [
      {
        "id": "01-Common-Types-of-Cyber-Threats-to-Businesses",
        "titleGuess": "Common Types Of Cyber Threats To Businesses"
      },
      {
        "id": "02-Information-Protection-&-Regulatory-Compliance",
        "titleGuess": "Information Protection & Regulatory Compliance"
      }
    ]
  }
] as const;
